import { GeneralSettings, Navigation, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutShipmentStatusErrorsCustomerService } from "./autogen/AutogenLayoutShipmentStatusErrorsCustomerService";
import { Snackbar } from "@mcleod/components";

export class ShipmentStatusErrorsCustomerService extends AutogenLayoutShipmentStatusErrorsCustomerService {
    labelTotalCountOnClick() {
        const urlParams: string[]= [];
        urlParams.push("shipmentStatusError=true");
        Navigation.navigateTo("lme/dispatch/planning/csm/CustomerServiceMultiProfile" + UrlUtil.buildQueryString(urlParams))
    }

    afterExecution() {
        const message = this.mainDataSource?.data[0]?.get("message");
        if (!StringUtil.isEmptyString(message) && GeneralSettings.hasEarlyAdoptersAccess()) {
            Snackbar.showWarningSnackbar(message);
        }
    }
}